import {React, useState, useRef} from "react";
import clsx from "clsx";
import {Container, Form} from "react-bootstrap";
import { useHistory } from "react-router";
import Image from "react-bootstrap/Image";
import _ from "lodash";
import { useSelector } from "react-redux";
import * as paymentSelectors from "../../../selectors/payment";
import Helper from "../../../utils/Helper";
import { useForm } from "react-hook-form";
import Enviornment from "../../../utils/Enviornment";
import * as axiosInstance from "../../../services/axiosInstance";
import {getUserAccountSymbol} from "../../../selectors/user";
import * as userSelectors from "../../../selectors/user";

function FPXTransfer({ label, items, paymentConfig }) {
  let history = useHistory();
  let paymentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const total = useSelector((state) => paymentSelectors.getPaymentTotalAmount(state));
  const paymentAmount = useSelector((state) => paymentSelectors.getPaymentTotal(state));
  const currency = useSelector((state) => paymentSelectors.getPaymentCurrency(state));
  const paymentItems = useSelector((state) => paymentSelectors.getPaymentItems(state));
  const fpxBanks = paymentSelectors.getPaymentConfigFpxBanks(paymentConfig);
  // const currency = useSelector((state) => userSelectors.getUserAccountCurrencySelected(state.user));
  const handleBack = (e) => {
    e.preventDefault()
    history.goBack();
  };

  const {
    register,
    handleSubmit,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    // reValidateMode: "onChange",
    defaultValues: {

      payment_amount: paymentAmount,
      deposit_amount:  _.isNaN(Number(total) - Number(paymentAmount)) ? 0 : Number(total) - Number(paymentAmount),
      contracts: _.map(paymentItems, (item) => {
        const subTotal = _.get(item, ["subTotal"], 0);
        const contractReference = _.get(item, ["data", "contract_reference"], "");
        return {
          contract_reference: contractReference,
          payment_amount: subTotal,
        };
      }),
      success_redirect_url: Enviornment.PAYMENT_REDIRECT_URL,
      failure_redirect_url: Enviornment.PAYMENT_REDIRECT_URL,
    },
  });

  const handleFormSubmit = async (values) => {
    setLoading(true);

    try {
      const response = await axiosInstance.post("clientarea/payment/online-payment", values, true, false);
      const paymentResponse = _.get(response, ["payment_request", "data"], null);
      paymentFormSubmit(paymentResponse);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const paymentFormSubmit = (paymentResponse) => {
    paymentRef.current.method = "POST"
    paymentRef.current.action = paymentResponse.url
    for (const key in paymentResponse) {
      if (key === "url") continue;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = paymentResponse[key];
      paymentRef.current.appendChild(input);
    }

    paymentRef.current.submit();
  };

  return (
      <Container fluid>
        <div className={"primary-border-table-border"} style={{backgroundColor: "white"}}>
          <div className={clsx("custom-card-label-container text-center")}>
            <h2>Online Banking</h2>
          </div>
          <br/>
          <Form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="fpx-transfer-content">
              <div className="fpx-transfer-content-inner">
                <div className="fpx-transfer-content-input padding-12px">
                  <p className="fpx-transfer-content-inner-label">Pay with </p>
                  <div className="fpx-logo-content">
                    <Image src="/img/fpx-logo-2.png" rounded style={{width: "100px"}}/>
                    <p>( Current & Savings Account )</p>
                  </div>
                </div>
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Total</p>
                  <Form.Control
                      value={`${userSelectors.getUserAccountSymbol(currency)}${Helper.formattedPrice(total)}`}
                      readOnly={true}
                  ></Form.Control>
                  <Form.Control {...register("payment_amount")} hidden={true} readOnly={true}/>
                  <Form.Control {...register("deposit_amount")} hidden={true} readOnly={true}/>
                  <Form.Control {...register("success_redirect_url")} hidden={true} readOnly={true}/>
                  <Form.Control {...register("failure_redirect_url")} hidden={true} readOnly={true}/>
                </div>
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Select Bank</p>
                  <Form.Select {...register("bank_id")}>
                    <option value="">Select Bank</option>
                    <optgroup label="Retail Banking:">
                      {_.map(fpxBanks, (bank, index) => {
                        const code = _.get(bank, ["code"], "");
                        const name = _.get(bank, ["name"], "");
                        const status = _.get(bank, ["status"], "");
                        return (
                            <option disabled={status === "B"} key={index} value={code}>
                              {name}
                              {status === "B" ? ` (Offline)` : ""}
                            </option>
                        );
                      })}
                    </optgroup>
                  </Form.Select>
                </div>
                <div className="fpx-transfer-content-input padding-12px my-2">
                  <p className="fpx-transfer-content-inner-label">Client Remarks</p>
                  <Form.Control {...register("client_remarks")} />
                </div>
                <p className="my-3 padding-12px ">
                  By clicking on <span className="text-bold-600">“Proceed”</span> button, you hereby agree with
                  <a href={Enviornment.FPX_TERM_AND_CONDITIONS_LINK} target="_blank">
                    {` FPX’s Terms & Conditions`}
                  </a>
                </p>
                <div className="d-flex justify-content-center py-3">
                  <button className={clsx("btn custom-button-back")} onClick={handleBack}>
                    Back
                  </button>
                  <button
                      className={clsx("btn custom-button-primary")}
                      type="submit"
                      style={{backgroundColor: "#9D7905"}}
                      disabled={_.isEmpty(watch('bank_id'))}

                  >
                    Proceed
                  </button>
                </div>
                <div className={clsx("payment-card-title mt-3 justify-content-end w-100")}>
                  <h6>Powered By</h6>
                  <img src="/img/fpx-logo-2.png" className="payment-card-watermark-image"></img>
                </div>
              </div>
            </div>
          </Form>
          <form ref={paymentRef}>

          </form>
          <br/>
        </div>
      </Container>
  );
}

export default (FPXTransfer);
